"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Pagination = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _Pagination = require("./Pagination.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 分頁
 */
var Pagination = function Pagination(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "default" : _ref$variant,
      _ref$textcolor = _ref.textcolor,
      textcolor = _ref$textcolor === void 0 ? "#fff" : _ref$textcolor,
      _ref$current = _ref.current,
      current = _ref$current === void 0 ? 1 : _ref$current,
      _ref$defaultCurrent = _ref.defaultCurrent,
      defaultCurrent = _ref$defaultCurrent === void 0 ? 1 : _ref$defaultCurrent,
      _ref$pageSizeOptions = _ref.pageSizeOptions,
      pageSizeOptions = _ref$pageSizeOptions === void 0 ? [100, 25, 20, 15, 10] : _ref$pageSizeOptions,
      total = _ref.total,
      onChange = _ref.onChange,
      _ref$defaultPageSize = _ref.defaultPageSize,
      defaultPageSize = _ref$defaultPageSize === void 0 ? 10 : _ref$defaultPageSize;
  return /*#__PURE__*/_react.default.createElement(_Pagination.UiPagination, {
    variant: variant,
    textcolor: textcolor
  }, total > 0 && total > defaultPageSize && /*#__PURE__*/_react.default.createElement(_antd.Pagination, {
    current: current,
    defaultCurrent: defaultCurrent,
    pageSizeOptions: pageSizeOptions,
    total: total,
    onChange: onChange,
    defaultPageSize: defaultPageSize
  }));
};

exports.Pagination = Pagination;
var _default = Pagination;
exports.default = _default;
Pagination.propTypes = {
  variant: _propTypes.default.string,
  textcolor: _propTypes.default.string,
  current: _propTypes.default.number,
  defaultCurrent: _propTypes.default.number,
  pageSizeOptions: _propTypes.default.array,
  total: _propTypes.default.number,
  onChange: _propTypes.default.func,
  defaultPageSize: _propTypes.default.number
};